module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--rules@3x-a01ee5d230c7cf0a494087527f45bcc4.jpg";